import { Navigate, Route, Routes } from "react-router-dom";
import React, {useState} from "react";
import LoggedInLayout from "./layouts/LoggedInLayout";
import GuestLayout from "./layouts/GuestLayout";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";
import Toast from "./components/toast/Toast";
import {GuestRoutes, UserRoutes} from "./routes";
import CreditModal from "./components/paymentsSection/CreditModal";
import PricingPlanModal from "./components/paymentsSection/PricingPlanModal";
import {GlobalModalContext} from "./context/GlobalModalsContext";
import useUserContext from "./hooks/useUserContext";

const CatchAll = () => {
    const { user } = useUserContext();
    return <Navigate to={user?.email ? "/dashboard" : "/start"} replace />;
};

const ProtectedLoginInLayout = () => <ProtectedRoute><LoggedInLayout/></ProtectedRoute>;

const AppWithContext = () => {
    const [isCreditModalOpen, setIsCreditModalOpen] = useState(false);
    const [isPricingPlanModalOpen, setIsPricingPlanModalOpen] = useState(false);

    return (
        <>
            <GlobalModalContext.Provider value={{
                isCreditModalOpen,
                setIsCreditModalOpen,
                isPricingPlanModalOpen,
                setIsPricingPlanModalOpen,
            }}>
                <Routes>
                    <Route element={<ProtectedLoginInLayout />}>
                        {UserRoutes.map(route => <Route key={route.path} path={route.path} element={route.element}></Route>)}
                    </Route>
                    <Route element={<GuestLayout />}>
                        {GuestRoutes.map(route => <Route key={route.path} path={route.path} element={route.element}></Route>)}
                    </Route>
                    <Route path="*" element={<CatchAll />} />
                </Routes>
                <Toast />
                <CreditModal isOpen={isCreditModalOpen} toggle={() => setIsCreditModalOpen(!isCreditModalOpen)} onClose={() => setIsCreditModalOpen(false)} />
                <PricingPlanModal isOpen={isPricingPlanModalOpen} toggle={() => setIsPricingPlanModalOpen(!isPricingPlanModalOpen) } />
            </GlobalModalContext.Provider>
        </>
    )
}

export default AppWithContext;